import React from 'react';

// The admin is wider than the public site (max-w-7xl): the articles table and
// the editor's two columns need the room on a PC. SiteHeader matches it.
export const ADMIN_MAX_WIDTH = 'max-w-[1440px]';

export default function AdminShell({ title, countLabel, actions, children }) {
  return (
    <main className={`flex-grow w-full ${ADMIN_MAX_WIDTH} mx-auto px-4 py-5 md:px-8 md:py-6 space-y-5`}>
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1">
          <h1 className="text-2xl font-bold text-white">{title}</h1>
          {countLabel ? <span className="text-sm font-medium text-slate-400">{countLabel}</span> : null}
        </div>
        {actions ? <div className="flex flex-wrap gap-2">{actions}</div> : null}
      </div>
      {/* min-w-0: a grid item is at least as wide as its content by default, so
          one long row (a sideways-scrolling filter row, a long link) used to
          stretch the whole page past a phone's screen. */}
      <div className="grid gap-4 md:grid-cols-2 [&>*]:min-w-0">{children}</div>
    </main>
  );
}
